<div class="estimate-appointments">
  <div class="ui-g-12 pt-1 pr-1 pl-1 pb-0">
    <!-- <div class="ui-g-12 p-0"> -->
    <button id="btn-estimate-add-appointment" [disabled]="isArchived" [disabled]="isArchived"
      class="custom-button btn btn-primary btn-block btn-submit font-12 font-bold" (click)="createAppointment()">
      +&nbsp;Appointment
    </button>
    <!-- </div> -->
  </div>

  <div class="ui-g-12  pt-1 pr-1 pl-1 pt-0 pb-0" *ngIf="estimate?._id">
    <div class="ui-g-12 p-0 estimate-appointment-row" *ngIf="appointments?.length > 0">
      <div class="ui-g-12 p-2 pb-2 bb-light" [ngClass]="{ 'disabled-estimate-field': isArchived }">
        <div *ngFor="let appointment of appointments" [hidden]="appointment.status === 'cancelled'"
          (click)="editAppointment(appointment)" class="flex-start-center pointer pb-2">
          <div class="flex-start pt-1">
            <i class="fal fa-calendar-alt font-14 pr-2"></i>
          </div>
          <div class="flex-column flex-center-start">
            <a class="appointment font-color font-600 font-12">
              {{appointment?.title}}
            </a>
            <span class="font-12  font-gray" *ngIf="appointment?.startDateTime">
              {{appointment?.startDateTime | date : 'MMM d, yyyy h:mm a'}}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!appointments?.length" class="paddingtb-12 pr-0 pl-0 bb-light">
      <div class="flex-center-center pb-3 pt-3 font-12 bg-light font-gray font-light pb-2">
        <div class="p-1">
          There are no appointments scheduled
        </div>
      </div>
    </div>
  </div>
</div>
